import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import CardiometabolicInflammationCombined from "./index";

const CardiometabolicInflammationWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={CardiometabolicInflammationCombined}
    keyControlsId="cardiometabolic-inflammation-key"
    {...props}
  />
);

export default CardiometabolicInflammationWithToggleKey;
